(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-bn-recommendations]').forEach(grid => {
      if (grid.dataset.initialized) return;
      grid.dataset.initialized = 'true';
      const slots = Array.from(grid.children);
      const used = new Set([grid.dataset.product, ...slots.filter(s => s.dataset.random === 'fixed').map(s => s.dataset.handle)]);
      slots.filter(s => s.dataset.random !== 'fixed').forEach(slot => {
        const candidates = Array.from(slot.querySelectorAll('template[data-candidate]')).filter(t => !used.has(t.dataset.candidate));
        if (!candidates.length) return;
        const key = `bn-recommendations-v1:${grid.dataset.product}:${slot.dataset.slot}:${candidates.map(t => t.dataset.candidate).join(',')}`;
        let saved;
        try { saved = sessionStorage.getItem(key); } catch (_) { /* Storage may be disabled. */ }
        const chosen = candidates.find(t => t.dataset.candidate === saved) || candidates[Math.floor(Math.random() * candidates.length)];
        try { sessionStorage.setItem(key, chosen.dataset.candidate); } catch (_) { /* Keep this page usable without storage. */ }
        slot.dataset.handle = chosen.dataset.candidate;
        used.add(chosen.dataset.candidate);
        slot.replaceChildren(chosen.content.cloneNode(true));
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
